import Loader from '@component/Loader';

export const AppLoader = () => {
  return (
    <div className="absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center overflow-hidden">
      <Loader className="w-[58px] h-[68px]" />
    </div>
  );
};
